import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Spin, Card, Tag, Tree, Button, Tooltip, Typography, Icon } from 'antd';

import styles from './style.less';

import { Nav } from '../Nav';
import TaxonomyBrowser from '../TaxonomyBrowser';
import EmbeddedComments from '../EmbeddedComments';

const { Text } = Typography;

class HomePageComponent extends Component {

  onGoonExit = () => {
    this.props.history.push(`/challenges`);
  }

  onTakeTheTest = () => {
    this.props.history.push(`/test-your-english-language-cefr-level`);
  }

  render() {

    return (
      <>
        <Card bordered={false} >{/* title="Welcome stranger," */}
          <h2>Welcome stranger!</h2>

          <p>Learning English, aren't you? How about taking an English grammar test? Assess your CEFR level with our auto-generated, reusable test and receive personalized feedback on your grammar strengths and weaknesses. Take the test multiple times to track your progress and improve with ease.</p>

          <Button type="primary" size="large" className={styles.controlButton} onClick={this.onTakeTheTest}><Icon type="check-square" theme="outlined" /> Take the Test!</Button>

          <p>We have a number of English "challenges" — practice exercises categorized with tags. <Link to="/challenges" rel="nofollow">Take</Link> any of them to validate your knowledge of English grammar.
          All challenge questions answers come with easily digestible explanations.</p>
  								
          <Button size="large" className={styles.controlButton} onClick={this.onGoonExit}><Icon type="arrow-right" theme="outlined" />Go to Challenges...</Button>

  				<p>If you are interested in something specific, maybe a grammar catergory like <Link to="/challenges/verb-tense">verb tenses</Link> or 
  				a popular language test like <Link to="/challenges/ielts">IELTS</Link> or something else, use our fancy taxonomy browser to <Tooltip title="hopefully"><Text underline>get</Text></Tooltip> challenges on whatever subject you want.
          Expand the categories under "Challenges by tag" to see all the topics.
          </p>

  				<p><Nav.LoginLink>Log in</Nav.LoginLink> using your email
          or social account to save your progress or <Nav.RegisterLink>register</Nav.RegisterLink> if you don't have an account yet.</p>

          <h2>Challenges by tag</h2>
          {this.props.taxonomy.trees.length ? (
            <TaxonomyBrowser taxonomy={this.props.taxonomy} history={this.props.history} />
          ) : (
            <div>
              <Spin className={styles.treeSpinner} size="large" />&nbsp;Loading tree...
            </div>
          ) }
  				<p></p>
  				<details><summary>Read more about the tags...</summary>
  				<p></p>
  				<p><strong>English Grammar</strong> is probably the most interesting tag tree here. If you are interested in improving your writing skills,
  				you might want to expand different branches asking yourself questions like "Do I even understand what <Link to="/tags/determiner"><em>determiner</em></Link> means". 
  				If you don't feel that this is the case, you might <Link to="/tags/determiner">click the tag</Link> to make sure.  
  				This set of tags comprises our <Link to="/article/tags">current attempt</Link> to categorise English grammar. They are not set in <Tooltip title="in fact they are set in utf-8"><Text underline>stone</Text></Tooltip>, and we will continue to develop the taxonomy to be as useful as possible.
  				</p>
          <p><Link to="/tags/cefr-level">CEFR</Link> here stands for the <strong>C</strong>ommon <strong>E</strong>uropean <strong>F</strong>ramework of <strong>R</strong>eference for Languages, and it is a set of descriptors to help us to
           measure our ability at language.</p>
          <p><Link to="/tags/difficulty-level">Difficulty Levels</Link> reflect the respective authors' opinions about how difficult questions and challenges are.</p>
  				<p><strong>Other good stuff</strong> is a catch-all category for what's left. International language tests, <Link to="/challenges/humor">humor</Link>, idioms, you know, all these things with so much in common.</p>
  				</details>
        </Card>
        <EmbeddedComments path="/" title="News" />
      </>
    );
  }
}

export default HomePageComponent;
